export default __webpack_public_path__ + "static/media/alertIcon.1addf7f8.svg";